import { nsNotifRules } from '@/app/i18n/namespaces';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { PUSH_PAYMENTS } from '../../api/apiUrls';
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
import notifRulesFields from '../../fields/notifRulesFields';

const NotifRulesImportProps = {
    apiUrl: PUSH_PAYMENTS.NOTIF_RULES.FILE_ACTION.url,
    namespace: nsNotifRules,
    fileExampleProperties: {
        name: 'notification_rules_example.csv',
        path: '/static/resource/files/notification_rules_example.csv'
    },
    uploadProperties: {
        fileExtAccepted: ['.csv'],
        typeOfUpload: 'text',
        invalidFileEntity: 'modal.import.error.invalid_file'
    },
    countLines: (fileData) => {
        const lines = fileData.split('\n');
        const addRuleActionRegex = /^AJOUTER$/i;
        const deleteRuleActionRegex = /^SUPPRIMER$/i;
        const counters = {
            add: 0,
            delete: 0
        };
        for (const line of lines) {
            const [operation] = line.split(';');
            if (addRuleActionRegex.test(operation)) {
                ++counters.add;
            } else if (deleteRuleActionRegex.test(operation)) {
                ++counters.delete;
            }
        }
        return { numberOfLines: counters, file: fileData };
    },
    explanations: () => {
        return (<>
            <Entity entity='modal.import.explanations.header' namespace={nsNotifRules} />
            <ul className='list-disc list-outside [&_ul]:list-[revert] ml-8'>
                <li><Entity entity='modal.import.explanations.action' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.recipient' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.partner' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.contract' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.rank' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.bankCode' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.application' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.extra1' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.extra2' namespace={nsNotifRules} /></li>
                <li><Entity entity='modal.import.explanations.label' namespace={nsNotifRules} /></li>
            </ul>
        </>);
    },
    confirmation: (numberOfLines) => {
        return <Entity
            entity='modal.import.confirmation'
            namespace={nsNotifRules}
            data={{ add: numberOfLines.add, delete: numberOfLines.delete }}
        />;
    },
    isFileOnError: (fileDetails) => {
        // Only counts rules with contract number written
        return fileDetails?.notProcessedRules?.filter(rule => rule.contract).length > 0;
    },
    renderPostImportErrors: (fileDetails, error) => {
        const rulesProcessed = fileDetails?.processedRules?.length ?? 0;
        const rulesNotProcessed = fileDetails?.notProcessedRules?.filter(rule => rule.contract).length ?? 0;

        return (
            <div className='centered'>
                {error &&
                    <Entity entity={'modal.import.error.UNEXPECTED_ERROR'} namespace={nsNotifRules} />
                }
                {rulesNotProcessed > 0 &&
                    <>
                        <Entity entity={'modal.import.error.header'} data={{ rulesProcessed: rulesProcessed }} namespace={nsNotifRules} />
                        {
                            fileDetails.notProcessedRules.filter(rule => rule.contract).map(rule => (
                                <div key={rule.contract}>
                                    <hr className='my-2' />
                                    <DetailsGrid data={{ notProcessedRules: rule }}
                                        fields={{
                                            recipient: notifRulesFields.RULES_NOT_PROCESSED.RECIPIENT,
                                            partner: notifRulesFields.RULES_NOT_PROCESSED.PARTNER,
                                            contract: notifRulesFields.RULES_NOT_PROCESSED.CONTRACT,
                                            rank: notifRulesFields.RULES_NOT_PROCESSED.RANK,
                                            bankCode: notifRulesFields.RULES_NOT_PROCESSED.BANK_CODE,
                                            application: notifRulesFields.RULES_NOT_PROCESSED.APPLICATION,
                                            extra1: notifRulesFields.RULES_NOT_PROCESSED.EXTRA_1,
                                            extra2: notifRulesFields.RULES_NOT_PROCESSED.EXTRA_2,
                                            label: notifRulesFields.RULES_NOT_PROCESSED.LABEL
                                        }} />
                                </div>
                            ))}
                    </>
                }
            </div>
        );
    }
};

export default NotifRulesImportProps;